import { TypeSocialNetworks } from "../types/Type_Weather";

export const socialNetworks: TypeSocialNetworks[] = [
  {
    id: 1,
    social_network: 'Facebook',
    url: 'https://www.facebook.com/alexvalverde666',
    icon: 'Facebook-Icon'
  },
  {
    id: 2,
    social_network: 'Instagram',
    url: 'https://www.instagram.com/alexvalverde._/',
    icon: 'Instagram-Icon'
  },
  {
    id: 3,
    social_network: 'LinkedIn',
    url: 'https://www.linkedin.com/in/alexvdev/',
    icon: 'LinkedIn-Icon'
  },
  {
    id: 4,
    social_network: 'Github',
    url: 'https://github.com/aleexvdev',
    icon: 'Github-Icon'
  },
]